export default __webpack_public_path__ + "media/videobackground.2b9fa4e8.mp4";